// const $BASE_API = "http://localhost/tu_registro_backend";
// const $BASE_REST = "http://localhost/tu_registro_backend/web";
const $TUREGISTRO = "https://inscripciondev.jeds.ar"
const $BASE_API = "https://apituregistro.desajeds.com.ar";
const $BASE_REST = "https://apituregistro.desajeds.com.ar/web";

export const environment = {
      production: false,
      baseRest: $BASE_REST,
      turegistro: $TUREGISTRO,
      login: {
            users: `${$BASE_REST}/view_usuario_logins`,
            //users: `${$CARGA_WEB}/usuarios_login.php`,
            login: `${$BASE_REST}/pev_seg_usuario/login`,
            view_usuarios: `${$BASE_REST}/view_usuarios`
      },
      reset_password: `${$BASE_REST}/pev_seg_usuario_data/recuperar`,
      controlador: `${$BASE_API}/controlador`,
      menu: `${$BASE_REST}/pev_com_menus`,
      pev_seg_usuario: {
            token: `${$BASE_REST}/pev_seg_usuario/token`,
            roles: `${$BASE_REST}/pev_seg_usuario/roles`,
            perfil: `${$BASE_REST}/pev_seg_usuario_data/get_datos`,
            editar_perfil: `${$BASE_REST}/pev_seg_usuario_datas`,
            profesores: `${$BASE_REST}/pev_seg_usuario_data/profesores`
      },
      administracion: {
            empresas: {
                  view_empresa: `${$BASE_REST}/view_empresas`,
                  empresa: `${$BASE_REST}/pev_emp_empresas`,
                  ver_logo_empresa: `${$BASE_REST}` // uploads/nombre_imagen se lo concatena en save.component.ts
            },
            usuarios: {
                  usuario_datas: `${$BASE_REST}/pev_seg_usuario_datas`,
                  view_usuario: `${$BASE_REST}/view_usuarios`,
                  usuarioRoles: `${$BASE_REST}/pev_seg_usuario_data/roles`,
                  inactivarUsuarioRoles: `${$BASE_REST}/pev_seg_usuario_data/inactivar_rol`,
                  getDueniosAsignarEmpresa: `${$BASE_REST}/pev_seg_usuario_data/get_duenos`,
                  asignarEmpresaGuardar: `${$BASE_REST}/pev_seg_usuario_data/asignar_duenos`,
                  asignarRolAUsuario: `${$BASE_REST}/pev_seg_usuario_data/get_rol`,
                  asignarRolAUsuarioGuardar: `${$BASE_REST}/pev_seg_usuario_data/asignar_rol`,
                  ver_foto_usuario: `${$BASE_REST}`, // uploads/nombre_imagen se lo concatena en save.component.ts
                  get_roles:`${$BASE_REST}/pev_seg_usuario_data/get_roles`,
                  permiso_indicadores:`${$BASE_REST}/pev_seg_usuario_data/permiso_indicadores`,
                  asignar_profe_team: `${$BASE_REST}/pev_seg_usuario_data/profe_team`,
                  habilitar_usuario: `${$BASE_REST}/pev_seg_usuario_data/habilitar`,
                  deshabilitar_usuario: `${$BASE_REST}/pev_seg_usuario_data/deshabilitar`,
            },
            cuentas_mp: {
                  view_cuentas_mp: `${$BASE_REST}/pev_emp_empresa/listado_mp`,
                  alta_mp: `${$BASE_REST}/pev_emp_empresa/alta_mp`,
                  editar_mp: `${$BASE_REST}/pev_emp_empresa/editar_mp`
            }
      },
      configuraciones: {
            configuracion: {
                  view_configuracion_tipo: `${$BASE_REST}/pev_com_configuracion?pagination=true&filter[idconfiguraciontipo]=`,
                  pev_com_configuracions: `${$BASE_REST}/pev_com_configuracions`
            }
      },
      proyectos: {
            proyectos: {
                  view_proyectos: `${$BASE_REST}/view_proyectos`,
                  proyectos: `${$BASE_REST}/pev_pro_proyectos`,
                  rechazar_proyecto: `${$BASE_REST}/pev_pro_proyecto/rechazar`,
                  aprobar_proyecto: `${$BASE_REST}/pev_pro_proyecto/aprobar`,
                  rendiciones: `${$BASE_REST}/pev_pro_proyecto/rendiciones`,
                  rendicion: `${$BASE_REST}/pev_pro_proyecto/rendicion_items`,
                  rendir_rendicion: `${$BASE_REST}/pev_pro_proyecto/rendir`,
                  eliminar_rendicion: `${$BASE_REST}/pev_pro_proyecto/eliminar_rendicion`,
                  eventos_compatibles: `${$BASE_REST}/pev_pro_proyecto/compatibilidad`,
                  evento_compatibles_guardar: `${$BASE_REST}/pev_pro_proyecto/compatible`,
                  exportar_rendicion: `${$BASE_REST}/pev_pro_proyecto/excel_rendicion_items`,
                  descarga_excel: `${$BASE_API}`,
            },
            eventos: {
                  view_eventos: `${$BASE_REST}/view_eventos`,
                  evento: `${$BASE_REST}/pev_pro_eventos`,
                  evento_compartido: `${$BASE_REST}/pev_pro_evento/compartido`,
                  configuracion_evento: `${$BASE_REST}/pev_pro_evento/configuracion`,
                  get_datos_configuracion: `${$BASE_REST}/pev_pro_evento/get_datos_configuracion`,
                  save_datos_configuracion: `${$BASE_REST}/pev_pro_evento/save_datos_configuracion`,
                  ver_certificado: `${$BASE_REST}`, // uploads/nombre_imagen se lo concatena en certificado.component.ts
                  configuracion_mensajes: {
                        get_mensaje_disparador: `${$BASE_REST}/pev_ins_inscripcion/get_mensaje_disparador`,
                        configuracion_mensaje: `${$BASE_REST}/pev_com_configuracion_mensajes`
                  },
                  pagos: {
                        resumen_pagos: `${$BASE_REST}/pev_ins_pago/resumen`
                  },
                  integrantes: {
                        integrantes_evento: `${$BASE_REST}/pev_pro_evento/integrantes`,
                        realizar_factura: `${$BASE_REST}/pev_ins_pago/facturar`
                  },
                  exportar_excel_evento: `${$BASE_REST}/pev_pro_evento/excel`,
                  exportar_excel_resumen_pagos: `${$BASE_REST}/pev_ins_pago/excel_resumen`,
                  descarga_excel: `${$BASE_API}`, // /web/uploads/integrantes_evento_13_1733863995.xlsx se lo concatena cuando se realice la descarga
                  medio_pagos: `${$BASE_REST}/pev_pro_evento/get_formas_pago`,
                  renumerar_evento: {
                        numeracion_no_disponible: `${$BASE_REST}/pev_pro_evento/numeracion_no_disponible`,
                        numerar: `${$BASE_REST}/pev_pro_evento/numerar`
                  },
                  acreditaciones: {
                        integrantes_acreditacion: `${$BASE_REST}/pev_pro_evento/integrantes_acreditacion`,
                        acreditar: `${$BASE_REST}/pev_pro_evento/acreditar`
                  },
                  imprimibles: {
                        generar_imprimibles: `${$BASE_REST}/pev_pro_evento/generar_imprimibles`,
                        ver_imprimibles: `${$BASE_REST}` // uploads/path_pdf se lo concatene en imprimibles.component.ts
                  },
                  grupos: {
                        grupo: `${$BASE_REST}/pev_pro_evento/grupo`,
                        integrantes_grupo: `${$BASE_REST}/pev_pro_evento/companero`,
                        cambiar_integrante: `${$BASE_REST}/pev_pro_evento/cambiar_companero`,
                  }
            },
            inscripciones: {
                  view_inscripciones: `${$BASE_REST}/pev_ins_inscripcion/integrantes`,
                  pagos : {
                        listado_pagos: `${$BASE_REST}/pev_ins_pago/listado`,
                        realizar_pago: `${$BASE_REST}/pev_ins_pago/realizar_pago`,
                        editar_pago: `${$BASE_REST}/pev_ins_pago/realizar_pago`,
                        modificar_valor_inscripcion: `${$BASE_REST}/pev_ins_inscripcion/modificar_valor`,
                        pago_realizado: `${$BASE_REST}/pev_ins_pago/get_pago_realizado`,
                        pago_inscripcion_detalle: `${$BASE_REST}/pev_ins_pago/pago_detalle`,
                        eliminar_pago_realizado: `${$BASE_REST}/pev_ins_pago/eliminar_pago_realizado`,
                        eliminar_pago_inscripcion_realizada: `${$BASE_REST}/pev_ins_pago/eliminar_pago`,
                        bonificacion_penalidad:  `${$BASE_REST}/pev_ins_pago/ajuste_alta`,
                        eliminar_bonificacion_penalidad: `${$BASE_REST}/pev_ins_pago/ajuste_eliminar`,
                        recibo: `${$BASE_REST}/pev_ins_pago/recibo`,
                        enviar_recibo: `${$BASE_REST}/pev_ins_pago/enviar_recibo`
                  },
                  papelera: {
                        levantar_papelera: `${$BASE_REST}/pev_ins_pago/levantar_papelera`
                  },
                  invitado: {
                        marcar_como_invitado: `${$BASE_REST}/pev_ins_inscripcion/invitado`
                  },
                  edicion_inscripcion: `${$BASE_REST}/pev_seg_usuario_data/token_participante`,
                  mantiene_inscripcion: `${$BASE_REST}/pev_ins_inscripcion/mantiene_inscripcion`,
                  cambio_proyecto_evento: `${$BASE_REST}/pev_ins_inscripcion/cambio_evento`,
                  renumerar_participante: {
                        numeros_disponibles: `${$BASE_REST}/pev_pro_evento/numeracion_disponible`,
                        asignar_numero: `${$BASE_REST}/pev_pro_evento/asignar_numero`
                  }
            }
      },
      facturas: {
            factura: `${$BASE_REST}/view_factura_listado`,
            reporte_comprobante: `${$BASE_REST}/pev_fee_factura/reporte_comprobante_pdf`,
            regenerar_factura: `${$BASE_REST}/pev_fee_factura/generar_comprobante`,
            anular_comprobante: `${$BASE_REST}/pev_fee_factura/anular_comprobante`
      },
      teams: {
            view_teams: `${$BASE_REST}/pev_tea_teams`,
            team: `${$BASE_REST}/pev_tea_teams`,
            miembros: `${$BASE_REST}/pev_tea_team/miembros`,
            importar: `${$BASE_REST}/pev_tea_team/importar`,
            descuentos: {
                  view_descuentos: `${$BASE_REST}/pev_tea_team/descuentos`,
                  descuento_alta: `${$BASE_REST}/pev_tea_team/descuento_alta`,
                  descuento_baja: `${$BASE_REST}/pev_tea_team/descuento_baja`
            }
      },
      acreditacion: {
            eventos_activos: `${$BASE_REST}/pev_pro_evento/eventos_activos`
      },
      select: {
            configuracion: `${$BASE_REST}/select/configuracion?idconfiguraciontipo=`,
            buscadorEmpresa: `${$BASE_REST}/select?modelo=PevEmpEmpresa&campo_id=idempresa&campo_descripcion=razon_social&campo_activo=`,
            roles: `${$BASE_REST}/selects?modelo=PevSegRol&campo_id=idrol&campo_descripcion=descripcion&campo_activo=activo`,
            paises: `${$BASE_REST}/selects?modelo=PevComPais&campo_id=idpais&campo_descripcion=descripcion&campo_activo`,
            provincia: `${$BASE_REST}/select/provincia?idpais=`,
            localidad: `${$BASE_REST}/select/localidad?idprovincia=`,
            tipo_proyecto: `${$BASE_REST}/selects?modelo=PevProProyectoTipo&campo_descripcion=descripcion&campo_id=idproyectotipo&campo_activo=activo`,
            proyecto: `${$BASE_REST}/select?modelo=PevProProyecto&campo_id=idproyecto&campo_descripcion=nombre&campo_activo=`,
            genero: `${$BASE_REST}/select/configuracion?idconfiguraciontipo=22`,
            tipo_indumentaria: `${$BASE_REST}/select/configuracion?idconfiguraciontipo=23`,
            genero_indumentaria: `${$BASE_REST}/select/configuracion?idconfiguraciontipo=24`,
            talle_indumentaria: `${$BASE_REST}/select/configuracion?idconfiguraciontipo=25`,
            disciplina: `${$BASE_REST}/select/configuracion?idconfiguraciontipo=11`,
            estado_evento: `${$BASE_REST}/select/configuracion?idconfiguraciontipo=26`,
            disparador: `${$BASE_REST}/select/configuracion?idconfiguraciontipo=27`,
            medios_pago: `${$BASE_REST}/select/configuracion?idconfiguraciontipo=28`,
            forma_pago: `${$BASE_REST}/select/realizar_pago_forma_pago`,
            eventos: `${$BASE_REST}/select?modelo=PevProEvento&campo_id=idevento&campo_descripcion=nombre&campo_activo=`,
            cambio_evento: `${$BASE_REST}/select/evento?idproyecto=`,
            condiciones_iva: `${$BASE_REST}/selects?modelo=PevFeeCondicion&campo_id=idcondicion&campo_descripcion=descripcion&campo_activo=activo`,
            tipo_identificacion: `${$BASE_REST}/select/configuracion_registro?idconfiguraciontipo=1`,
            nacionalidades: `${$BASE_REST}/select/configuracion_registro?idconfiguraciontipo=6`
      },
};

